// extracted by mini-css-extract-plugin
module.exports =  {"popover-trigger-wrapper":"BzpGXlf","popoverTriggerWrapper":"BzpGXlf","hide-trigger":"NwP1wlm","hideTrigger":"NwP1wlm"};